import { MouseEvent } from 'react';
import { DocumentItem } from '../types/content';
import { useLanguage } from '../i18n/LanguageContext';
import { downloadDoc, getDocDisplayTitle, getDocFileName } from '../utils/documents';

type DocumentLinksProps = {
  documents?: DocumentItem[];
  className?: string;
};

export function DocumentLinks({ documents, className }: DocumentLinksProps) {
  const { t } = useLanguage();
  if (!documents || documents.length === 0) return null;

  return (
    <div className={className || 'inline-docs'}>
      {documents.map((doc) => (
        <a
          key={doc.id}
          href={doc.fileUrl || '#'}
          rel="noreferrer"
          className="inline-doc"
          title={t(getDocDisplayTitle(doc))}
          download={getDocFileName(doc)}
          onClick={(event: MouseEvent<HTMLAnchorElement>) => downloadDoc(event, doc)}
        >
          {t(getDocDisplayTitle(doc))}
        </a>
      ))}
    </div>
  );
}
